import * as React from 'react';

export const SubsectionTitle = () => {
  return <span />;
};
